export default __webpack_public_path__ + "static/media/mask12.9364cf76.jpeg";